import { render, staticRenderFns } from "./BusinessContactView.vue?vue&type=template&id=1dfe8f21"
import script from "./BusinessContactView.vue?vue&type=script&lang=js"
export * from "./BusinessContactView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports